import { Link } from "react-router-dom";
import { BrandMark } from "./BrandMark";
import { formatVerifiedDate } from "@/lib/brandHours";
import { Phone, MessageSquare } from "lucide-react";

export default function BrandCard({ brand, index = 0 }) {
  return (
    <Link
      to={`/brand/${brand.slug}`}
      data-testid={`brand-card-${brand.slug}`}
      className="group flex flex-col justify-between border border-hair bg-transparent p-5 transition-transform duration-150 ease-out hover:-translate-y-[2px] hover:border-ink focus-visible:border-ink"
    >
      <div className="flex items-center gap-3">
        <BrandMark name={brand.name} color={brand.color} />
        <div className="min-w-0">
          <div className="truncate font-serif text-lg font-medium text-ink">{brand.name}</div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-muted">
            {brand.category}
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between border-t border-hair pt-3">
        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] text-muted">
          {brand.phone ? (
            <>
              <Phone className="h-3.5 w-3.5" /> Phone
            </>
          ) : (
            <>
              <MessageSquare className="h-3.5 w-3.5" /> Online
            </>
          )}
        </span>
        {brand.verified_on && (
          <span className="font-mono text-[11px] text-accent">
            ✓ {formatVerifiedDate(brand.verified_on)}
          </span>
        )}
      </div>
    </Link>
  );
}
